import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-analytics" }

import { onMounted } from 'vue'


export default {
  __name: 'Analytics',
  setup(__props) {

onMounted(() => {
    try {
        const script = document.createElement('script')
        script.defer = true
        script.src = 'https://ana.102465.xyz/hello'
        script.setAttribute('data-website-id', '61825d9e-9921-44de-adc7-8152ca5c24d5')
        document.head.appendChild(script)
        console.log('Analytics script loaded')
    } catch (error) {
        console.error('Failed to load Analytics script:', error)
    }
})

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

}